import { render, staticRenderFns } from "./Gerk.vue?vue&type=template&id=825343b6&"
import script from "./Gerk.vue?vue&type=script&lang=js&"
export * from "./Gerk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports